module.exports = __webpack_public_path__ + "img/CAGLIARI.720f7bb8.png";